


import FETCHING from '../../library/fetching'
import DATA_MASTER from '../../library/dataMaster'
import UMUM from '../../library/umum'

export default {
  data() {
    return {

      form : {
        id : '',
        opdterlapor: '',
        judullaporan : '',
        deskripsi : '',
        tahun : '',
        tipe:'',
        file : null,
        status : '',
        rating : '',
        ratingx : '',
        feedback : '',

      },

      list_data : [],
      list_lampiran : [],
      list_surat : [],
      list_opdterlapor:[],
      list_tipe:[
                  { uraian: 'Umum', id: 1 },
                  { uraian: 'Anonim', id: 2 }
                ],

      cari_value: "",
      page_first: 1,
      page_last: 0,
      page_limit : 10,

      page_first1: 1,
      page_last1: 0,
      page_limit1 : 10,
      cek_load_data : true,


      mdl_rating: false,
      mdl_dokumen: false,
      mdl_riwayat: false,
      mdl_ratingx: false,



      FETCHING : FETCHING,
      DATA_MASTER : DATA_MASTER,
      UMUM : UMUM,

      file_old : "",
      file_path: this.$store.state.url.URL_APP + "uploads/",
    }
  },
  methods: {

    getView : function(){
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_FEEDBACK + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value,
              page_limit: this.page_limit,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.cek_load_data = false;
            console.log(res_data);
      });
    },


    diterima : function() {
        fetch(this.$store.state.url.URL_FEEDBACK + "diterima", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
           body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Melakukan Rating Pengaduan', 'primary', 'check_circle_outline');
          this.getView();
      });
    },

    selectData : function(data){
        this.form.id = data.id;
        this.form.judul = data.judul;
        this.form.deskripsi = data.deskripsi;
        this.form.tahun = data.tahun;
        this.form.tipe = data.tipe;
        this.form.status = data.status;
        this.form.file = data.file;
        this.file_old = data.file;
        this.form.aduan = data.aduan;
        this.form.verifikasi = data.verifikasi;
        this.form.keterangan_ver = data.keterangan_ver;
        this.form.tindaklanjut = data.tindaklanjut;
        this.form.keterangan_tl = data.keterangan_tl;
        this.form.feedback = data.feedback;
        this.form.ratingx = data.ratingx;
        
    },
    

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },
        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


    // ====================================== PAGINATE ====================================




        // async awaitFetch(){
        //   this.$store.state.list_mapel = await this.DATA_MASTER.getopdterlapor(this.form.opdterlapor_id_id);
        // }


  },

  mounted () {
    var get_profile = JSON.parse(localStorage.profile);
    this.getView();
  },
}
